<template>
  <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('palletReceipt.receivedPallets')"
    :visible.sync="dialogVisible"
    width="34%"
    id="print-received-pallet-receipts-dialog"
    :before-close="handleClose"
    v-on:closed="$emit('close-dialog')">
    <el-form :model="searchForm" :rules="formRules" ref="searchForm" label-position="right" size="mini" inline class="text-align-end">
        <el-row>
          <el-col class="form-vertical-item">
            <el-form-item :label="$t('palletReceipt.warehouse')">
               <el-input
                v-model="user.warehouseCode"
                ref="filter-layout-template"
                disabled
                class="inline-input"
                id="searchForm-warehouse"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col class="form-vertical-item">
            <el-form-item :label="$t('palletReceipt.dayOfServiceFrom')" prop="dayOfServiceFrom">
              <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchForm.dayOfServiceFrom"
                  format="MM/dd/yyyy"
                  :clearable="false"
                  type="date"
                  id="searchForm-date-of-service-from"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="form-vertical-item">
            <el-form-item :label="$t('palletReceipt.dayOfServiceTo')" prop="dayOfServiceTo">
              <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchForm.dayOfServiceTo"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-date-of-service-to"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close-dialog')" size="mini">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handlePrint" size="mini" class="margin-r-18" id="btn-print">{{ $t('palletReceipt.print') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  computed: {
    ...mapGetters([
      'palletReceipt',
      'user'
    ])
  },
  props: ['displayDialog'],
  data() {
    return {
      dialogVisible: this.displayDialog,
      searchForm: {
        dayOfServiceFrom: null,
        dayOfServiceTo: null
      },
      formRules: {
        dayOfServiceFrom: [
          { required: true, message: this.$t('palletReceipt.error.dateFromRequired'), trigger: 'blur' }
        ],
        dayOfServiceTo: [
          { required: true, message: this.$t('palletReceipt.error.dateToRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    displayDialog(newValue) {
      this.dialogVisible = newValue;
    }
  },
  methods: {
    handleClose(done) {
      done();
    },
    handleOpen() {
      this.searchForm.dayOfServiceFrom = this.palletReceipt.actualFilters.dayOfServiceFrom;
      this.searchForm.dayOfServiceTo = this.palletReceipt.actualFilters.dayOfServiceTo;
    },
    async handlePrint() {
      const loading = Loading.service(constants.LOADING.PRINT_PALLET_RECEIPT_CONFIG);
      const validForm = await this.$refs.searchForm.validate().catch(() => {});
      if (validForm) {
        await this.$store.dispatch('palletReceipt/printReceivedPallets', this.searchForm);
      }
      loading.close();
    }
  }
};
</script>
